import { Logger } from '@gef-ui/logging';
import assocPath from "ramda/es/assocPath";
import identity from "ramda/es/identity";
import isNotNil from "ramda-extension/es/isNotNil";
import { CALL_API } from '../../../../constants';
import { logApiInfoError } from '../../../utils';
import { createErrorObject } from '../createErrorObject';
import { parseXhrContent } from '../parseXhrContent';
export const createXhrError = async (response, callAPI, requestParams, contentParser = parseXhrContent, actionMeta, action)=>{
    let error = response;
    try {
        await logApiInfoError(error.xhr.responseText);
    } catch (_e) {
        Logger.info(`Error handling: error.xhr.responseText not available on this response type`);
    }
    try {
        error = {
            status: response.status,
            statusText: response.xhr.statusText,
            responseHeaders: response.xhr.getAllResponseHeaders(),
            traceparent: response.xhr.getResponseHeader('traceparent'),
            parsedContent: contentParser(response),
            requestParams,
            meta: actionMeta,
            message: response.xhr.statusText,
            _originalAction: action?.[CALL_API] && isNotNil(action[CALL_API].originalNotReportError) ? assocPath([
                CALL_API,
                'notReportError'
            ], action[CALL_API].originalNotReportError, action) : action
        };
        const errorManipulation = callAPI.errorManipulation ?? identity;
        error = errorManipulation(error, requestParams);
    } catch (_) {
        error = createErrorObject(response);
    }
    return error;
};
